/**
 * AddressModel
 */
class AddressModel {
    /**
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} company
     * @param {string} email
     * @param {string} phonenumber
     * @param {string} streetAddress
     * @param {string} apartment
     * @param {string} city
     * @param {string} state
     * @param {string} zip
     */
    constructor(firstName='', lastName='', company='',
        email='', phonenumber='',
        streetAddress='', apartment='', city='',
        state='', zip='') {
        this.first_name = firstName
        this.last_name = lastName
        this.company = company
        this.email = email
        this.phonenumber = phonenumber
        this.street_address = streetAddress
        this.apartment = apartment
        this.city = city
        this.state = state
        this.zip = zip
    }

    /**
     * @param {json} json
     * @return {AddressModel}
     */
    static from(json) {
        const address = Object.assign(new AddressModel(), json)
        return address
    }

    /**
     * Fill in information need like a copy
     * @param {json} shipping
     * @param {boolean} overrideFill
     */
    fillInInformation(shipping, overrideFill) {
        const params = ['first_name', 'last_name', 'company', 'email', 'phonenumber',
                        'street_address', 'apartment', 'city', 'state', 'zip']
        for (let i = 0; i < params.length; i++) {
            if (this[params[i]].length === 0 || overrideFill) {
                this[params[i]] = shipping[params[i]]
            }
        }
    }
}

module.exports = {
    AddressModel,
}
